import { Component, HostListener, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Meta } from '@angular/platform-browser';
@Component({
  selector: 'piqet-angular-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  showScroll = false;
  showScrollHeight = 100;
  hideScrollHeight = 5;
  isDashboard!: boolean;
  urlChecker!: Subscription;
  currentYear: any;
  appVersion: string = '';
  constructor(private router: Router, private meta: Meta) {}

  ngOnInit() {
    const date = new Date();
    this.appVersion = this.meta.getTag('name="app-version"')?.content || 'Release: v5';
    this.currentYear = date.getFullYear();
    this.urlChecker = this.router?.events.subscribe((event: any) => {
      this.isDashboard = event?.routerEvent?.url?.includes('/dashboard');
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) >
      this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) <
        this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  ngOnDestroy() {
    this.urlChecker.unsubscribe();
  }
}
